<template>
  <div
    v-if="iconToShow.length > 0"
    class="user-information">
    <span
      v-for="(language, index) in iconToShow"
      :key="index"
      :class="['languages', language.name]"
      data-wptv="fip-languages">
      <wptv-icon
        v-if="language.hasIcon"
        :name="language.name"
        :invert="invert"
        :data-wptv="`fip-${language.name}-icon`"
        width="100%"
        height="100%" />
      <span
        v-else
        :data-wptv="`fip-${language}-icon`"
        class="language background-icon"> {{ language }}</span>
    </span>
  </div>
</template>

<script>
import { WptvIcon } from '@wptv/components/ui/icon'
import API_CONSTANTS from '../../../../api.constants'

export default {
  name: 'FipUserInformations',
  components: {
    WptvIcon
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    invert: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const languages = this.item.definitions
      .map(item => item.languageVersion)
      .filter((item, idx, self) => (idx === self.indexOf(item)))

    return {
      iconToShow: [
        ...languages,
        this.isHD() ? API_CONSTANTS.LANGUAGES.HD : '', // check and add txt value for switch to get linked icon
        this.isAD() ? API_CONSTANTS.LANGUAGES.QAD : '',
        this.isHI() ? API_CONSTANTS.LANGUAGES.HI : ''
      ]
        .filter(Boolean)
        .map(this.getIconForLanguage)
    }
  },
  methods: {
    isHD () {
      return this.item.definitions && this.item.definitions.some(item => item.quality === API_CONSTANTS.LANGUAGES.HD)
    },
    isAD () {
      return this.item.definitions.some((item) => {
        return item.languages && item.languages.some(item => item.language === API_CONSTANTS.LANGUAGES.QAD.toLowerCase())
      })
    },
    isHI () {
      return this.item.definitions.some((item) => {
        return item.subtitles && item.subtitles.some(item => item.hearingImpaired === true)
      })
    },
    getIconForLanguage (language) {
      switch (language) {
        case API_CONSTANTS.LANGUAGES.VOST_VF :
          return { name: 'vostfr-vf', hasIcon: true }
        case API_CONSTANTS.LANGUAGES.VF:
          return { name: 'vf', hasIcon: true }
        case API_CONSTANTS.LANGUAGES.VOST:
          return { name: 'vostfr', hasIcon: true }
        case API_CONSTANTS.LANGUAGES.HD:
          return { name: 'hd-2', hasIcon: true }
        case API_CONSTANTS.LANGUAGES.QAD:
          return { name: 'audio-description-3', hasIcon: true }
        case API_CONSTANTS.LANGUAGES.HI:
          return { name: 'hearing-impaired-2', hasIcon: true }
        default:
          return language
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .user-information{
    margin-top: 14px;
    display: inline-flex;
    align-items: center;
    @include mediaQueries('max-height', (xsmall: 25px, large: 18px));

    .languages {
      @include mediaQueries('height', (xsmall: 25px, large: 18px));
      @include mediaQueries('width', (xsmall: 50px, large: 40px));
      display: inline-flex;

      &:not(:first-child) {
        margin-left: 10px;
      }

      &.vostfr-vf {
        @include mediaQueries('height', (xsmall: 52px, large: 42px));
        @include mediaQueries('width', (xsmall: 88px, large: 63px));
        margin-top: -2px;

        img {
          object-fit: contain;
        }
      }

      &.vf {
        @include mediaQueries('height', (xsmall: 52px, large: 42px));
        @include mediaQueries('width', (xsmall: 35px, large: 30px));
        margin-top: -2px;
      }

      &.vostfr {
        @include mediaQueries('height', (xsmall: 52px, large: 42px));
        @include mediaQueries('width', (xsmall: 55px, large: 40px));
      }

      &.audio-description-3 {
        @include mediaQueries('height', (xsmall: 25px, large: 42px));
        @include mediaQueries('width', (xsmall: 45px, large: 32px));
      }

      &.hearing-impaired-2 {
        @include mediaQueries('height', (xsmall: 25px, large: 18px));
        @include mediaQueries('width', (xsmall: 25px, large: 18px));
      }

      &.hd-2 {
        @include mediaQueries('height', (xsmall: 25px, large: 18px));
        @include mediaQueries('width', (xsmall: 44px, large: 30px));
      }
    }

    .language {
      padding: 4px;
    }
  }
</style>
